// eslint-disable-next-line import/prefer-default-export, no-useless-escape
export var phone = function phone(value) {
  return /^(|[0-9]{1,}[0-9\-]{3,15})$/.test(value) || 'Provide a valid phone number';
};